import { Component, OnInit } from '@angular/core';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';
import { AvantoModalControlService } from 'src/app/services/avanto-modalControl.service';
import { Router, NavigationStart } from '@angular/router';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mobile-navbar',
  templateUrl: './mobile-navbar.component.html',
  styleUrls: ['./mobile-navbar.component.scss']
})
export class MobileNavbarComponent implements OnInit {

  isOnInitialScreen = false;
  isOneRestaurantMode:boolean;
  sessionObserver: Subscription;
  selectedRestaurantId:string;
  numberOfItemsInsideOfCart: number;



  constructor(private avantoRoute:AvantoRoutingService,  private avantoSession: AvantoSessionService, private avantoModal: AvantoModalControlService, private angularRouter: Router) { }

  ngOnInit() {
    this.isOneRestaurantMode = false;

    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      this.numberOfItemsInsideOfCart = session.cart.cartItems.size;
      this.isOneRestaurantMode = session.isOneRestaurantMode;
      if(this.isOneRestaurantMode && session.restaurantInformation!=null){
          this.selectedRestaurantId = session.restaurantInformation.restaurantId
      }
    });

    this.updateLayout(this.angularRouter.url); 
    //The following code observes which route the user is at and act accordingly
    this.angularRouter.events.subscribe(event => {
      //Override values - depends on the page
      if (event instanceof NavigationStart) {
        this.updateLayout(event.url)
      }
    })
  }

  updateLayout(route) {
    this.isOnInitialScreen = false;
    if (route == "/") {
      this.isOnInitialScreen = true;
    }
  }

  restaurantBtnClicked(){
    if(this.isOneRestaurantMode==false){
      this.avantoRoute.goToChooseRestaurantPage();
    }else{
      const restaurantIdSplit = this.selectedRestaurantId.split(".")
      this.avantoRoute.goToOneRestaurantModeChooseFoodPage(restaurantIdSplit[0],restaurantIdSplit[1])
    }
  }
  myAccountBtnClicked(){
    this.avantoRoute.goToCustomerDashboardPage();
  }
  viewCartBtnClicked(){
    this.avantoModal.openCartModal();
  }
}
